export default __webpack_public_path__ + "static/media/people_en.182b5a51.png";